import { Routes, Route, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Home from "../Pages/Home/Home";
import Booking from "../Pages/Booking/Booking.jsx";
import Navbar from "../Main/Navbar/Navbar";
import Footer from "../Main/Footer/Footer";
import EventsPage from "../Pages/Products/Event/EventsPage";
import Passportguide from "../Pages/Products/Passport/Passportguide";
import GovtFeeHistory from "../Pages/Products/GovernmentFee/GovtFeeHistory";
import Login from "../Pages/Users/Login";
import Profile from "../Pages/Users/Profile";
import USMockInterview from "../Pages/Products/Interview/USMockInterview";
import Requirements from "../Pages/Products/visaRequirement/Requirements";
import RefundPolicy from "../Pages/Products/Refund/RefundPolicy";
import { useAuth } from "../../context/AuthContext";
import ScrollToTop from "./ScrollToTop";
import Detail  from "../Pages/Products/VisaDetails/Detail";
import Esim  from "../Pages/Products/Esim/Esim.jsx";
import ShoppingMart  from "../Pages/Products/Shopping/ShoppingMart";
import VisaCareer  from "../Pages/Products/Career/VisaCareer";
import Schenegenchecker  from "../Pages/Products/ScheneganAppointment/SchenegenChecker";
import About            from "../Pages/Products/About/About";
import ScheduleMeeting from "../Pages/Products/ScheduleMeeting/ScheduleMeeting";
import AdminRouting from "../Admin-TVC/AdminRouting";
import { GOOGLE_CLIENT_ID } from "../../config";


function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/login" />;
}

function Router() {
  const { logout } = useAuth();
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <ScrollToTop />
      <Navbar />

        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/visa/:visaId" element={<Booking />} />
        <Route path="/schedule-meeting" element={<ScheduleMeeting />} />
        <Route path="/interview" element={<USMockInterview />} />
        <Route path="/requirements" element={<Requirements />} />
        <Route path="/GovtFeeHistory" element={<GovtFeeHistory />} />
        <Route path="/EventsPage" element={<EventsPage />} />
        <Route path="/Passportguide" element={<Passportguide />} />
        <Route path="/refund" element={<RefundPolicy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/Detail" element={<Detail />} />
        <Route path="/Esim" element={<Esim />} />
        <Route path="/ShoppingMart" element={<ShoppingMart />} />
        <Route path="/VisaCareer" element={<VisaCareer />} />
        <Route path="/SchenegenChecker" element={<Schenegenchecker />} />
        <Route path="/about" element={<About />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile onLogout={logout} />
            </ProtectedRoute>
          }
        />

        <Route path="/admin/*" element={<AdminRouting />} />
        <Route path="/manager/*" element={<AdminRouting />} />
        <Route path="/staff/*" element={<AdminRouting />} />
      </Routes>

      <Footer />
    </GoogleOAuthProvider>
  );
}

export default Router;
